export default "<div class=\"reportCardWrapper\">\n    <img src=\"{{imageSrc}}\" />\n  <div class=\"cardFooter\">{{title}}</div>\n</div>\n"